<template>
  <v-container 
    id="treinamentos2"
    fluid grey darken-3
    class="pa-0 my-0 py-12"
  >
    <v-row
      class="pt-12 justify-center"
    >
      <v-col cols="12" class="text-center">
        <h3 class="body-1 font-weight-regular pt-3">
          <span class="barlow grey--text text--lighten-2">treinamentos para sua carreira</span>
        </h3>
        <h2 class="display-1 font-weight-bold pt-0">
          <span class="barlow primary--text">FORMAÇÕES</span>
        </h2>
      </v-col>
    </v-row>
    <v-row
      class="pt-8 pb-12 px-12 justify-center"
    >
      <v-col
        v-for="(t,i) in treinamentos"
        :key="i"
        cols="12"
        sm="6"
        md="4"
      >
        <v-card tile flat hover
          class="fill-height white grey--text text--darken-4 text-left" 
          :href="t.url"
        >
          <v-row class="ma-0 fill-height">
            <v-col cols="6" md="6" class="pa-0">
              <v-img 
                :src="getImg(t.imagem)" 
                class="fill-height"
              >
              </v-img>
            </v-col>
            <v-col cols="6" md="6" class="pa-1">
              <v-card-subtitle class="caption pt-4 pb-0 text-uppercase primary--text" v-text="t.categoria"></v-card-subtitle>
              <v-card-title class="body-1 pt-2 font-weight-medium" v-text="t.titulo"></v-card-title>
            </v-col>
          </v-row>

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//import posts from '~/store/posts'
// import axios from '~/plugins/axios'

export default {
  data: () => ({
    treinamentos: [
      {
        url: '',
        imagem: 'pnl-1.jpg',
        categoria: 'PNL',
        titulo: 'Formação Meta Practitioner em PNL e Neurosemântica',
        descricao: '',
        data: ''
      },
      {
        url: '',
        imagem: 'pnl-2.jpg',
        categoria: 'PNL',
        titulo: 'Formação Master Meta Practitioner em PNL e Neurosemântica',
        descricao: '',
        data: ''
      },
      {
        url: '',
        imagem: 'constelacao-1.jpg',
        categoria: 'CONSTELAÇÃO SISTÊMICA',
        titulo: 'Formação Constelação Sistêmica Familiar e Pensamento Sistêmico',
        descricao: '',
        data: ''
      },
      {
        url: '',
        imagem: 'psicologia-positiva-1.jpg',
        categoria: 'PSICOLOGIA',
        titulo: 'Formação Practitioner em Psicologia Positiva: A Ciência da Felicidade',
        descricao: '',
        data: ''
      },
      {
        url: '',
        imagem: 'psicologia-positiva-2.jpg',
        categoria: 'PSICOLOGIA',
        titulo: 'Formação Master Practitioner em Psicologia Positiva',
        descricao: '',
        data: ''
      },
      {
        url: '',
        imagem: 'analista-comportamental-1.jpg',
        categoria: 'PSICOLOGIA',
        titulo: 'Formação Analista Comportamental',
        descricao: '',
        data: ''
      },
      {
        url: '',
        imagem: 'pensamento-sistemico-1.jpg',
        categoria: 'COACH',
        titulo: 'Ferramentas de Pensamento Generativo e Sistêmico para Coaches',
        descricao: '',
        data: ''
      },
      {
        url: '',
        imagem: 'coach-1.jpg',
        categoria: 'COACH',
        titulo: 'Formação Professional Coach',
        descricao: '',
        data: ''
      },
      {
        url: '',
        imagem: 'coach-2.jpg',
        categoria: 'COACH',
        titulo: 'Formação Executive Coach',
        descricao: '',
        data: ''
      },
      {
        url: '',
        imagem: 'coach-3.jpg',
        categoria: 'COACH',
        titulo: 'Formação Business Coach',
        descricao: '',
        data: ''
      },
      {
        url: '',
        imagem: 'coach-4.jpg',
        categoria: 'COACH',
        titulo: 'Formação Master Executive Coach',
        descricao: '',
        data: ''
      },
      {
        url: '',
        imagem: 'coach-5.jpg',
        categoria: 'COACH',
        titulo: 'Formação Master Business Coach',
        descricao: '',
        data: ''
      },
    ],
  }),
  methods: {
    getImg(i) {
      return require('@/assets/img/treinamentos/formacao/'+i)
    },
  },
  created () {
    //this.posts = posts.getPosts()
  },

}
</script>